export default {
    title: "Support",
    description:
        "If you have any questions, please contact support via WhatsApp or consult our help center.",
    service_hours_title: "Service Hours:",
    service_hours_description:
        "Monday to Friday from 09:00 to 12:00 and from 13:00 to 17:00",
    whatsapp_button: "Service via WhatsApp",
    help_center_button: "View help center",
    emergency_title: "On-call Support:",
    emergency_description:
        "For emergency requests outside our service hours, please fill out the on-call form.",
    emergency_button: "On-call Form",
};
